













































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import FiltersMixin from "@/mixins/SpecialInitiatives/FiltersMixin";
import TaxonomySelectV2 from "@/components/TaxonomySelectV2.vue";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import VWeekPicker from "@/components/VWeekPicker.vue";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import { Route } from "vue-router";
import SpecialInitiatives from "@/services/SpecialInitiavesService";
import {
  WeekPickerResult,
  WEEK_PICKER_MODALITY_DATE_RANGE,
  WEEK_PICKER_MODALITY_WEEK_RANGE,
} from "@/interfaces/WeekPickerDataTypes";
import HeatmapTable, {
  HeatmapTableColumn,
  HeatmapTableRow,
} from "@/components/HeatmapTable.vue";
import Broadcaster, {
  BroadcastersCatalog,
  BroadcastersCollection,
} from "@/models/SpecialInitiatives/Broadcaster";
import VSwitchButton from "@/components/VSwitchButton.vue";
import SpecialInitiativesTrendTable from "@/components/SpecialInitiatives/SpecialInitiativesTrendTable.vue";
import SpecialInitiativesChart, {
  ChartWeekRange,
} from "@/components/SpecialInitiatives/Chart.vue";
import SelectOption from "@/interfaces/SelectOption";
import VCheckButton from "@/components/VCheckButton.vue";
import TrendMixin, {
  SpecialInitiativesIColumn,
  SubjectColumn,
} from "@/mixins/http/SpecialInitiatives/TrendMixin";

@Component({
  components: {
    TaxonomySelectV2,
    MultiLevelSelect,
    VWeekPicker,
    VMultiSwitcher,
    HeatmapTable,
    VSwitchButton,
    SpecialInitiativesTrendTable,
    SpecialInitiativesChart,
    VCheckButton,
  },
})
export default class Trend extends Mixins(FiltersMixin, TrendMixin) {
  loading = false;
  disabled = false;

  broadcasters: BroadcastersCatalog = {};

  heatmapColumns: HeatmapTableColumn[] = [];
  heatmapRows: HeatmapTableRow[] = [];

  private chartTypeItems: Array<SelectOption> = [
    { id: "bar", text: "Barre" },
    { id: "line", text: "Linea" },
    { id: "pie", text: "Torta", disabled: true },
  ];

  chart = {
    settings: {
      stacked: false,
      percentage: false,
      type: "bar",
    },
  };

  chartItems: any[] = [];

  @Watch("heatmapRows")
  onHeatmapRowsChanged() {
    this.buildRowsForChart();
  }

  @Watch("subject")
  onSubjectChanged() {
    this.buildRowsForChart();
  }

  broadcastersToTableData(): Broadcaster[] {
    for (const weekRange in this.broadcasters) {
      return this.broadcastersFromExclusivity(
        this.exclusivity,
        this.broadcasters[weekRange]
      );
    }
    return [];
  }

  specialInitiativesPeriods(): SpecialInitiativesIColumn[] {
    return this.heatmapColumns
      .filter((column) => column.name !== "subject")
      .map((column) => {
        return {
          name: column.name,
          label: column.label,
        };
      });
  }

  tableSubject(): SubjectColumn {
    if (this.marketSubject) {
      return this.marketSubject as SubjectColumn;
    }
    return "market_segments" as SubjectColumn;
  }

  get currentIdUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.id || ""
      );
    } else {
      return "";
    }
  }

  get timeGranularityItems() {
    const result = VWeekPicker.convertResultToModality(
      this.weekRange,
      WEEK_PICKER_MODALITY_DATE_RANGE
    );
    if (result?.type === "date_range") {
      const start = this.$moment(result.start);
      const end = this.$moment(result.end);
      const difference = start.diff(end, "days");
      if (difference < -366) {
        if (this.timeGranularity === "month") {
          this.timeGranularity = "quarter";
        }
        return this.timeGranularityLongRanged;
      }
    }
    if (this.timeGranularity === "year") {
      this.timeGranularity = "semester";
    }
    return this.timeGranularityShortRanged;
  }

  get title() {
    const subject = this.marketSubjectsEntries.find(
      (element) => element.id === this.marketSubject
    );
    return `Trend ${subject?.text?.toLowerCase()}`;
  }

  get currentUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.text || ""
      );
    } else {
      return "";
    }
  }

  get shouldShowHeatmap() {
    return this.marketSubject === "broadcasters";
  }

  get noData(): boolean {
    const keys = Object.keys(this.broadcasters);
    let result = true;
    keys.forEach((key) => {
      result =
        result &&
        this.broadcastersFromExclusivity(
          this.exclusivity,
          this.broadcasters[key]
        ).length === 0;
    });
    return result;
  }

  get heatmapSortColumn() {
    if (this.heatmapColumns.length > 0) {
      return this.heatmapColumns[1];
    } else {
      return null;
    }
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.loading = true;
    if (this.forceReloadFromApi) {
      await this.loadBroadcasters();
    }
    this.initData();
    this.forceReloadFromApi = false;
    this.loading = false;
    next();
  }

  async mounted() {
    if (this.unitOfMeasurement?.match(/quoted/)) {
      this.unitOfMeasurement = "seconds";
    }
    await this.initFilters();
    await this.loadBroadcasters();
    this.initData();
  }

  async loadBroadcastersFromApi(weekRange: string) {
    const filter = this.filtersForAPI("trend");
    filter.weekRange = weekRange;
    const broadcastersAll = await SpecialInitiatives.getBroadcasters(filter);

    this.broadcasters[weekRange] = broadcastersAll.reduce(
      (acc, broadcaster) => {
        switch (broadcaster.exclusivityType) {
          case "mine":
            acc.broadcastersMine.push(broadcaster);
            break;
          case "others":
            acc.broadcastersOthers.push(broadcaster);
            break;
          case "shared":
            acc.broadcastersShared.push(broadcaster);
        }
        return acc;
      },
      {
        broadcastersAll,
        broadcastersMine: [] as Broadcaster[],
        broadcastersOthers: [] as Broadcaster[],
        broadcastersShared: [] as Broadcaster[],
      }
    );
  }

  async loadBroadcasters() {
    this.loading = true;
    this.broadcasters = {};
    const filter = this.filtersForAPI("trend");
    if (filter.weekRange) {
      await this.loadBroadcastersFromApi(filter.weekRange);
    }
    this.loading = false;
  }

  private columnFromUnitOfMeasurement() {
    if (this.unitOfMeasurement === "seconds") {
      return "secondsCount";
    } else if (this.unitOfMeasurement === "spots") {
      return "detectionsCount";
    } else {
      return "companiesCount";
    }
  }

  private getTotals(broadcasters: Broadcaster[]) {
    const fieldName = this.columnFromUnitOfMeasurement();
    if (fieldName === "companiesCount") {
      const companyIdsSet: Set<string> = new Set();
      broadcasters.reduce((acc, broadcaster) => {
        const companyIdsSplitted = broadcaster.companyIds.split(",");
        companyIdsSplitted.forEach((companyId) => {
          acc.add(companyId);
        });
        return acc;
      }, companyIdsSet);
      return companyIdsSet.size;
    } else {
      return broadcasters.reduce((acc, broadcaster) => {
        return acc + broadcaster[fieldName];
      }, 0);
    }
  }

  private cellValue(
    broadcaster: Broadcaster,
    before: number | Record<string, any> | null,
    previousValue: number | Record<string, any> | null
  ) {
    let cellValue = broadcaster[this.columnFromUnitOfMeasurement()];
    if (previousValue) {
      if (typeof previousValue === "object") {
        previousValue = (previousValue as any).value;
      }
      cellValue += previousValue as number;
    }
    if (before) {
      let beforeValue = 1;
      if (typeof before === "object") {
        beforeValue = (before as any).value;
      } else {
        beforeValue = before;
      }
      return {
        type: "trend",
        value: cellValue,
        trend: this.cellTrendFromBefore(broadcaster, beforeValue),
      };
    }
    return cellValue;
  }

  private cellZeroValue(
    database: { [key: string]: any },
    subject: string,
    columnName: string
  ) {
    let [year, period] = columnName
      .split("-")[1]
      .split("_")
      .map((s) => Number.parseInt(s));
    if (period === 1) {
      year--;
      period = 12;
    } else {
      period--;
    }
    const before = database[subject][`col-${year}_${period}`] || null;
    if (before) {
      return {
        type: "trend",
        value: 0,
        trend: -100,
      };
    } else {
      return {
        type: "trend",
        value: 0,
        trend: 0,
      };
    }
  }

  private cellTrendFromBefore(broadcaster: Broadcaster, before: number) {
    const cellCurrentValue = broadcaster[this.columnFromUnitOfMeasurement()];
    return (cellCurrentValue / before - 1) * 100;
  }

  private arrangeDataInTables() {
    const database: { [key: string]: any } = {};
    for (const weekRange in this.broadcasters) {
      const collection = this.broadcasters[weekRange];
      const broadcasters = this.broadcastersFromExclusivity(
        this.exclusivity,
        collection
      );
      const total = this.getTotals(broadcasters);
      broadcasters.forEach((broadcaster) => {
        if (broadcaster.timeGranularity) {
          if (this.timeGranularity !== "year") {
            let [year, period] = broadcaster.timeGranularity
              .split("_")
              .map((s) => Number.parseInt(s));
            period--;
            if (period < 1) {
              period = 12;
              year--;
            }
            const row = database[broadcaster.brandName] || {
              subject: broadcaster.name + "::" + broadcaster.logoUrls[0],
            };
            const before = row[`col-${year}_${period}`] || null;
            const value = row[`col-${broadcaster.timeGranularity}`] || 0;
            row[`col-${broadcaster.timeGranularity}`] = this.cellValue(
              broadcaster,
              before,
              value
            );
            database[broadcaster.brandName] = row;
          } else {
            const year = Number.parseInt(broadcaster.timeGranularity);
            const row = database[broadcaster.brandName] || {
              subject: broadcaster.name + "::" + broadcaster.logoUrls[0],
            };
            const before = row[`col-${year}`] || null;
            const value = row[`col-${broadcaster.timeGranularity}`] || 0;
            row[`col-${broadcaster.timeGranularity}`] = this.cellValue(
              broadcaster,
              before,
              value
            );
            database[broadcaster.brandName] = row;
          }
        }
      });
    }
    this.heatmapRows = [];
    for (const subject in database) {
      const row: any = {};
      row["subject"] = subject;
      this.heatmapColumns.forEach((column) => {
        row[column.name] =
          database[subject][column.name] ||
          this.cellZeroValue(database, subject, column.name);
      });
      this.heatmapRows.push(row);
    }
  }

  private columnsFromDateRangeAndTimeGranularity() {
    const filter = this.filtersForAPI("trend");
    if (filter.weekRange) {
      const [w1, y1, w2, y2] = filter.weekRange.split(",");
      const weekStart = Number.parseInt(w1);
      const yearStart = Number.parseInt(y1);
      const weekEnd = Number.parseInt(w2);
      const yearEnd = Number.parseInt(y2);
      switch (this.timeGranularity) {
        case "month":
          return this.columnsFromDateRangeAndMonthGranularity(
            weekStart,
            yearStart,
            weekEnd,
            yearEnd
          );
        case "quarter":
          return this.columnsFromDateRangeAndQuarterGranularity(
            weekStart,
            yearStart,
            weekEnd,
            yearEnd
          );
        case "semester":
          return this.columnsFromDateRangeAndSemesterGranularity(
            weekStart,
            yearStart,
            weekEnd,
            yearEnd
          );
        case "year":
          return this.columnsFromDateRangeAndYearGranularity(
            weekStart,
            yearStart,
            weekEnd,
            yearEnd
          );
      }
    }
  }

  private quarterToSemesterNumber(quarter: number) {
    let num = 0;
    switch (quarter) {
      case 1:
      case 2:
        num = 1;
        break;
      case 3:
      case 4:
        num = 2;
        break;
    }
    return num;
  }

  private quarterToSemesterLabel(quarter: number) {
    let label = "";
    switch (quarter) {
      case 1:
      case 2:
        label = "GEN-GIU";
        break;
      case 3:
      case 4:
        label = "LUG-DIC";
        break;
    }
    return label;
  }

  private quarterToLabel(quarter: number) {
    let label = "";
    switch (quarter) {
      case 1:
        label = "GEN-MAR";
        break;
      case 2:
        label = "APR-GIU";
        break;
      case 3:
        label = "LUG-SET";
        break;
      case 4:
        label = "OTT-DIC";
        break;
    }
    return label;
  }

  private notSameIsoMonth(period: moment.Moment) {
    const month = period.month();
    const checkMonth = period.clone().weekday(4).month();
    return month !== checkMonth;
  }

  private columnsFromDateRangeAndSemesterGranularity(
    weekStart: number,
    yearStart: number,
    weekEnd: number,
    yearEnd: number
  ) {
    if (weekStart === weekEnd && yearStart === yearEnd) {
      const week = this.$moment().isoWeek(weekStart).isoWeekYear(weekStart);
      const month: HeatmapTableColumn = {
        name: `col-${week.year()}_${this.quarterToSemesterNumber(
          week.quarter()
        )}`,
        label: `${this.quarterToSemesterLabel(week.quarter())} ${week.year()}`,
        heatmapDisabled: true,
      };
      return [month];
    } else {
      const start = this.$moment()
        .isoWeekYear(yearStart)
        .isoWeek(weekStart)
        .clone();
      const end = this.$moment().isoWeekYear(yearEnd).isoWeek(weekEnd).clone();
      const semesters: { [key: string]: HeatmapTableColumn } = {};
      for (
        let currentWeek = start;
        currentWeek.isSameOrBefore(end);
        currentWeek.add(1, "week")
      ) {
        if (this.notSameIsoMonth(currentWeek)) {
          continue;
        }
        semesters[
          `col-${currentWeek.year()}_${this.quarterToSemesterNumber(
            currentWeek.quarter()
          )}`
        ] = {
          name: `col-${currentWeek.year()}_${this.quarterToSemesterNumber(
            currentWeek.quarter()
          )}`,
          label: `${this.quarterToSemesterLabel(
            currentWeek.quarter()
          )} ${currentWeek.year()}`,
          heatmapDisabled: true,
        };
      }
      return Object.keys(semesters).map((key) => {
        return semesters[key];
      });
    }
  }

  private columnsFromDateRangeAndQuarterGranularity(
    weekStart: number,
    yearStart: number,
    weekEnd: number,
    yearEnd: number
  ) {
    if (weekStart === weekEnd && yearStart === yearEnd) {
      const week = this.$moment().isoWeek(weekStart).isoWeekYear(weekStart);
      const month: HeatmapTableColumn = {
        name: `col-${week.year()}_${week.quarter()}`,
        label: `${this.quarterToLabel(week.quarter())} ${week.year()}`,
        heatmapDisabled: true,
      };
      return [month];
    } else {
      const start = this.$moment()
        .isoWeekYear(yearStart)
        .isoWeek(weekStart)
        .clone();
      const end = this.$moment().isoWeekYear(yearEnd).isoWeek(weekEnd).clone();
      const quarters: { [key: string]: HeatmapTableColumn } = {};
      for (
        let currentWeek = start;
        currentWeek.isSameOrBefore(end);
        currentWeek.add(1, "week")
      ) {
        if (this.notSameIsoMonth(currentWeek)) {
          continue;
        }
        quarters[`col-${currentWeek.year()}_${currentWeek.quarter()}`] = {
          name: `col-${currentWeek.year()}_${currentWeek.quarter()}`,
          label: `${this.quarterToLabel(
            currentWeek.quarter()
          )} ${currentWeek.year()}`,
          heatmapDisabled: true,
        };
      }
      return Object.keys(quarters).map((key) => {
        return quarters[key];
      });
    }
  }

  private columnsFromDateRangeAndMonthGranularity(
    weekStart: number,
    yearStart: number,
    weekEnd: number,
    yearEnd: number
  ) {
    if (weekStart === weekEnd && yearStart === yearEnd) {
      const week = this.$moment().isoWeek(weekStart).isoWeekYear(weekStart);
      const colMonthName =
        week.month() < 10 ? `0${week.month()}` : `${week.month()}`;
      const month: HeatmapTableColumn = {
        name: `col-${week.year()}_${colMonthName}`,
        label: week.format("MMM YYYY").toUpperCase(),
        heatmapDisabled: true,
      };
      return [month];
    } else {
      const start = this.$moment()
        .isoWeekYear(yearStart)
        .isoWeek(weekStart)
        .clone();
      const end = this.$moment().isoWeekYear(yearEnd).isoWeek(weekEnd).clone();
      const months: { [key: string]: HeatmapTableColumn } = {};
      for (
        let currentWeek = start;
        currentWeek.isSameOrBefore(end);
        currentWeek.add(1, "week")
      ) {
        const month = currentWeek.month();
        const checkMonth = currentWeek.clone().weekday(4).month();
        if (month !== checkMonth) {
          continue;
        }
        const colMonthName = `${checkMonth + 1}`;
        months[`col-${currentWeek.year()}_${colMonthName}`] = {
          name: `col-${currentWeek.year()}_${colMonthName}`,
          label: currentWeek.format("MMM YYYY").toUpperCase(),
          heatmapDisabled: true,
        };
      }
      return Object.keys(months).map((key) => {
        return months[key];
      });
    }
  }

  private columnsFromDateRangeAndYearGranularity(
    weekStart: number,
    yearStart: number,
    weekEnd: number,
    yearEnd: number
  ) {
    if (weekStart === weekEnd && yearStart === yearEnd) {
      const week = this.$moment().isoWeek(weekStart).isoWeekYear(weekStart);
      const month: HeatmapTableColumn = {
        name: `${week.year()}`,
        label: `${week.year()}`,
        heatmapDisabled: true,
      };
      return [month];
    } else {
      const start = this.$moment()
        .isoWeekYear(yearStart)
        .isoWeek(weekStart)
        .clone();
      const end = this.$moment().isoWeekYear(yearEnd).isoWeek(weekEnd).clone();
      const months: { [key: string]: HeatmapTableColumn } = {};
      for (
        let currentWeek = start;
        currentWeek.isSameOrBefore(end);
        currentWeek.add(1, "week")
      ) {
        if (this.notSameIsoMonth(currentWeek)) {
          continue;
        }
        months[`col-${currentWeek.year()}`] = {
          name: `col-${currentWeek.year()}`,
          label: `${currentWeek.year()}`,
          heatmapDisabled: true,
        };
      }
      return Object.keys(months).map((key) => {
        return months[key];
      });
    }
  }

  private initData() {
    this.heatmapColumns = [
      {
        name: "subject",
        label: "Soggetto",
        heatmapDisabled: true,
        locked: true,
      },
    ];
    this.heatmapColumns = this.heatmapColumns.concat(
      this.columnsFromDateRangeAndTimeGranularity() || []
    );
    this.arrangeDataInTables();
  }

  private timeGranularityLabels(): ChartWeekRange[] {
    const res = this.heatmapColumns.slice(1).map((column) => {
      return {
        label: column.label,
        columnName: column.name,
      };
    });
    return res;
  }

  private parseSubjectNameAndLogo(name: string) {
    const match = name.match(/(.*)::(.*)/);
    if (match) {
      return {
        name: match[1],
        logo: match[2],
      };
    } else return name;
  }

  private buildRowsForChart(): void {
    if (this.shouldShowHeatmap) {
      const res = this.heatmapRows.map((row) => {
        const rowObj: any = {};
        Object.keys(row).map((key) => {
          const rowItem = row[key];
          if (key.startsWith("col-")) {
            if (rowItem.value) {
              rowObj[key] = rowItem.value;
            } else {
              rowObj[key] = rowItem;
            }
          }
          if (key.startsWith("subject")) {
            rowObj[key] = rowItem;
          }
        });
        return rowObj;
      });
      this.chartItems = res;
    } else {
      this.buildSpecialInitiativesColumnsAndRows(
        this.loading,
        this.tableSubject(),
        this.specialInitiativesPeriods(),
        this.exclusivity,
        this.unitOfMeasurement,
        this.broadcasters
      );
      const res = this.rows
        .filter((row) => !row.subject.startsWith("TOTALE"))
        .map((row) => {
          const rowObj: any = {};
          Object.keys(row.data).map((key) => {
            const rowItem = row.data[key];
            if (key.startsWith("col-")) {
              if (rowItem.value) {
                rowObj[key] = rowItem.value;
              } else {
                rowObj[key] = rowItem;
              }
            }
          });
          rowObj["subject"] = row.subject;
          return rowObj;
        });
      this.chartItems = res;
    }
  }
}
